import { render, staticRenderFns } from "./CustomerMemoTable.vue?vue&type=template&id=cb4d38b8"
import script from "./CustomerMemoTable.vue?vue&type=script&lang=js"
export * from "./CustomerMemoTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports